import React from 'react'
import { useTranslation } from 'react-i18next'
import NavBar, { NavBarItem } from '../NavBar'

export interface ColplAppSimpleTitleBarProps {
  title?: string // localized title of the navbar
  subTitle?: string // localized subtitle of the navbar
  items?: NavBarItem[] // items of the navbar
}

export function ColplAppSimpleTitleBar(props: ColplAppSimpleTitleBarProps) {
  const { t } = useTranslation()
  /*
  const { state, dispatch } = useClaimant()
  const subTitle = 'appl.case' + state.caseType
  */
  return (
    <NavBar
      title={props.title ?? t('appl.title')}
      subTitle={props.subTitle ?? ''}
      items={props.items}
    />
  )
}
